export { BrowseWordsPrimaryControlsStripExpansionContent } from "#browse-words-primary-controls-strip-expansion-content";
